<template>
  <div id="division">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'division'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/exhibition/prediction/GearList/Division.vue